import { isNil } from 'lodash';

import { Maybe } from '../gql/generated/graphql';

// TODO: use lodash isNil instead.
export const isNullOrUndefined = <T>(val: T | null | undefined): val is null | undefined =>
  val === null || val === undefined;

export const someIsNullOrUndefined = <T>(arr: T[]) => arr.some(isNil);

export function pluckDefined<T>(array?: Maybe<T>[]): T[];
// eslint-disable-next-line no-redeclare
export function pluckDefined<T, K extends keyof T>(array?: T[], prop?: K): Array<NonNullable<T[K]>>;
// eslint-disable-next-line no-redeclare
export function pluckDefined<T, K extends keyof T>(array?: Maybe<T>[], prop?: K) {
  const out: unknown[] = [];

  if (!array) {
    return out;
  }

  if (prop) {
    return array.reduce((acc, item) => {
      const value = item?.[prop];
      if (!isNil(value)) {
        acc.push(value);
      }
      return acc;
    }, out);
  }

  return array.reduce((acc, item) => {
    if (!isNil(item)) {
      acc.push(item);
    }
    return acc;
  }, out);
}
